import { gql } from '@apollo/client';

export const CreateOrganizationDomain = gql`
  mutation CreateOrganizationDomain($organizationCode: String!, $domainName: String!) {
    createOrganizationDomain(organizationCode: $organizationCode, domainName: $domainName) {
      name
      validated
      validationMode
      creationDate
      validationCode
      validationDate
      validationCodeExpirationDate
    }
  }
`;
